import { TimelineLite } from 'gsap/TimelineLite';

import { qs, qsa, isMobile } from '@/scripts/utils';

import { eventsListIn, eventsListOut } from '@/scripts/timelines/eventsListTransitions';
import { buttonIn, buttonOut } from '@/scripts/timelines/buttonsTransitions';
// import { canvasIn } from '@/scripts/timelines/canvasTransitions';
import { museletIn } from '@/scripts/timelines/museletTransitions';
import { uiIn, uiOut } from '@/scripts/timelines/uiTransitions';


const indexTransition = (el, dir, prevPage, callback) => {
  const tl = new TimelineLite();

  const eventsListInTl = () => eventsListIn(qsa('[js-anim="eventsList"]', el)).play();
  const buttonInTl = () => buttonIn(el).play(); // eslint-disable-line

  const footerInTl = () => {
    const animUiIn = uiIn(qs('footer'));
    animUiIn.play();
    animUiIn.eventCallback('onComplete', callback);
  };

  const headerInTl = () => {
    const animUiIn = uiIn(qs('header'));
    animUiIn.play();
  };

  const eventsListOutTl = () => eventsListOut(qsa('.js-splittedchars', el)).progress(1, false).timeScale(3).reverse();

  const buttonOutTl = () => {
    const animButtonOut = buttonOut(el);
    animButtonOut.play();
    animButtonOut.eventCallback('onComplete', callback);
  };

  const museletInTl = () => {
    const animMuseletIn = museletIn(document);

    animMuseletIn.play();
    animMuseletIn.eventCallback('onComplete', callback);
  };

  const footerOutTl = () => {
    uiOut(qs('footer')).play();
  };

  if (dir === 'in') {
    if (prevPage === 'loader') {
      tl
        .add(eventsListInTl, 0.2)
        .add(buttonInTl, 2)
        .add(headerInTl, 1)
        .add(footerInTl, 1.4);
    } else if (prevPage === 'event') {
      if (isMobile()) tl.add(footerInTl);
      tl.add(eventsListInTl, 0.2)
        .add(buttonInTl, 2)
        .add(museletInTl, 0);
    }
  } else {
    if (isMobile()) tl.add(footerOutTl);
    tl
      .add(eventsListOutTl)
      .add(buttonOutTl, 1);
  }

  return tl;
};

export default indexTransition;



// WEBPACK FOOTER //
// ./src/scripts/timelines/indexTransition.js